import { cloneDeep } from 'lodash';

export default class BaseModel {
  // temp: convert model
  serverDataConvertToModel(data, { deepClone } = { deepClone: false }) {
    Object.keys(this).forEach((key) => {
      this[key] = deepClone ? cloneDeep(data[key]) : data[key];
    });
  }
}
